import {
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
  useRef,
  MutableRefObject
} from 'react';
import { updateToken } from 'containerApp';

import { getTokens, putTokens, isTokenValid } from './tokenStore';
import { Tokens } from './types/Tokens';

class TokenEvent extends Event {
  public readonly tokens: Tokens;
  constructor(type: string, tokens: Tokens) {
    super(type);
    this.tokens = tokens;
  }
}

window.tokenEmitter = new EventTarget();

window.updateTokens = (tokens: Tokens) => {
  putTokens(tokens);
  window.tokenEmitter.dispatchEvent(new TokenEvent('update', tokens));
};

const subscribeTokenListener = (
  tokenRef: MutableRefObject<Tokens | null>
) => () => {
  const updateTokens = (event: Event): void => {
    const tokens = (event as TokenEvent).tokens;
    tokenRef.current = tokens;
    if (isTokenValid()) {
      updateToken(tokens); //sync token back to container app if applicable
    }
  };

  window.tokenEmitter.addEventListener('update', updateTokens);

  return () => {
    window.tokenEmitter.removeEventListener('update', updateTokens);
  };
};

export const useTokens = (): {
  tokenRef: MutableRefObject<Tokens | null>;
  hasValidToken: boolean;
  setHasValidToken: Dispatch<SetStateAction<boolean>>;
} => {
  const tokenRef = useRef<Tokens | null>(getTokens());
  const [hasValidToken, setHasValidToken] = useState(isTokenValid());

  useEffect(() => subscribeTokenListener(tokenRef)(), []);

  return {
    tokenRef,
    hasValidToken,
    setHasValidToken
  };
};
